import { NormalButton, NormalDate } from "component/common";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Polar } from "react-chartjs-2";

export class StudioReportsClass extends Component {
  state = {
    from_Date: new Date(),
    to_Date: new Date(),
  };

  handleDatePick = ({ target: { value, name } }) => {
    let { from_Date, to_Date } = this.state;

    if (name == "to_Date") {
      to_Date = value;
      this.setState({ to_Date });
    }

    if (name == "from_Date") {
      from_Date = value;
      this.setState({ from_Date });
    }
    this.setState({
      from_Date,
      to_Date,
    });
  };

  render() {
    let { from_Date, to_Date, chartData } = this.state;
    return (
      <div>
        <div className="col-md-12">
          <h1 className="my-4 reports-heading">Reports</h1>
        </div>
        <div className=" my-3 mx-3">
          <div className="row">
            <div className="mt-3 col-lg-3  col-sm-6 ">
              <span>{"From Date*"}</span>
              <div className="input-group">
                <NormalDate
                  value={from_Date}
                  name="from_Date"
                  showYearDropdown={true}
                  onChange={this.handleDatePick}
                  dateFormat="dd/MM/yyyy "
                />
              </div>
            </div>
            <div className="mt-3  col-lg-3  col-sm-6 ">
              <span>{"To Date*"}</span>
              <div className="input-group">
                <NormalDate
                  value={to_Date}
                  name="to_Date"
                  showYearDropdown={true}
                  dateFormat="dd/MM/yyyy"
                  type="date"
                  onChange={this.handleDatePick}
                />
              </div>
            </div>
          </div>
          <div className="my-4 pt-3 col-md-3 col-12">
            <NormalButton mainbg={true} label={"View Report"} />
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export const StudioReports = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(StudioReportsClass)
);
